// lib/upgradeIntent.js  (BL-038 Story 38.5 — Non-Billing Upgrade-Intent Path)
//
// Under Public Access Lockdown there is NO live billing: the Stripe checkout
// path is inert and the pricing page is waitlist-only. So a trial-expired or
// trial-low user who wants to upgrade must not be dead-ended into a checkout
// that cannot complete. Instead we capture their UPGRADE INTENT — a non-billing
// demand signal routed through the funnel instrumentation — and acknowledge it.
//
// When billing is later switched on (REACT_APP_BILLING_ENABLED, or the dev mock
// flag), the existing Stripe path takes over unchanged. This module only decides
// "is billing live?" and records the intent; it never charges, never touches
// Stripe, and stores no payment data (PCI surface stays zero).

import { trackFunnel, FUNNEL_EVENTS } from "./attribution";

// Billing is live only when explicitly enabled, or in the dev Stripe-mock
// environment (same build-flag convention as the mock checkout routes). In the
// production lockdown posture both are unset → billing is OFF.
export function isBillingEnabled() {
  return (
    process.env.REACT_APP_BILLING_ENABLED === "true" ||
    process.env.REACT_APP_STRIPE_MOCK === "true"
  );
}

// Record an upgrade-intent funnel event. `from` identifies the surface
// (paywall_gate | paywall_banner); `currentTier` is the user's tier at the time.
export function recordUpgradeIntent({ from, currentTier } = {}) {
  trackFunnel(FUNNEL_EVENTS.UPGRADE_INTENT, {
    from: from || null,
    current_tier: currentTier || null,
  });
}
